import { Link } from "react-router-dom";
import { ShieldCheck, Mail } from "lucide-react";
import { CONTACT_EMAIL } from "@/data/content";

export function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-sagedark text-cream/80 relative z-10"
        >
            <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
                <div>
                    <div className="flex items-center gap-2.5 mb-5">
                        <img
                            src="/logo.png"
                            alt="DentAssists logo"
                            className="w-11 h-11 rounded-full bg-cream/5"
                        />
                        <span className="font-heading text-xl text-cream">DentAssists</span>
                    </div>
                    <p className="text-sm leading-relaxed max-w-sm text-cream/70">
                        Insurance verification, billing, payment posting, AR follow-up,
                        credentialing, and reporting for dental practices across Texas and the U.S. —
                        inside the software you already use.
                    </p>
                    <div className="mt-6 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.15em] text-cream/60">
                        <ShieldCheck size={14} className="text-terracotta" />
                        HIPAA-compliant · Signed BAA
                    </div>
                    <a
                        href={`mailto:${CONTACT_EMAIL}`}
                        data-testid="footer-email-link"
                        className="mt-4 flex items-center gap-2 text-sm text-cream/80 hover:text-cream transition-colors duration-200"
                    >
                        <Mail size={15} className="text-terracotta" />
                        {CONTACT_EMAIL}
                    </a>
                </div>

                <div>
                    <p className="font-mono text-xs uppercase tracking-[0.2em] text-cream/50 mb-5">
                        Company
                    </p>
                    <ul className="space-y-3 text-sm">
                        <li>
                            <Link to="/services" className="hover:text-cream transition-colors duration-200">
                                Services
                            </Link>
                        </li>
                        <li>
                            <Link to="/about" className="hover:text-cream transition-colors duration-200">
                                Why DentAssists
                            </Link>
                        </li>
                        <li>
                            <Link to="/blog" className="hover:text-cream transition-colors duration-200">
                                Resources
                            </Link>
                        </li>
                        <li>
                            <Link to="/faq" className="hover:text-cream transition-colors duration-200">
                                FAQ
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact" className="hover:text-cream transition-colors duration-200">
                                Contact
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <p className="font-mono text-xs uppercase tracking-[0.2em] text-cream/50 mb-5">
                        Get started
                    </p>
                    <Link
                        to="/contact"
                        data-testid="footer-cta-button"
                        className="inline-block text-sm font-medium bg-terracotta text-cream px-5 py-3 rounded-sm transition-[background-color] duration-200 hover:bg-terracottadark"
                    >
                        Request a Consultation
                    </Link>
                </div>
            </div>

            <div className="border-t border-cream/10">
                <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-cream/50">
                    <span>© {new Date().getFullYear()} DentAssists. All rights reserved.</span>
                    <Link to="/admin/login" className="hover:text-cream/80 transition-colors">
                        Admin
                    </Link>
                </div>
            </div>
        </footer>
    );
}
